import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import { injectIntl } from 'react-intl';
import { grey500 } from 'material-ui/styles/colors';
import moment from 'moment';



function getCollapseTimePeriodFunction(timePeriod) {
  return (arr, { date, positive, total }) => {

    if (!total) {
      return arr;
    }

    const csat = (positive / total) * 100;
    const lastItemTimeMs = arr[arr.length - 1] && arr[arr.length - 1].x;
    const thisItemTimeMs = moment.utc(date).startOf(timePeriod).valueOf();
    if (lastItemTimeMs === thisItemTimeMs) {
      const lastCount = arr[arr.length - 1].count;
      const lastCsat = arr[arr.length - 1].y;
      arr[arr.length - 1].y = ((lastCount * lastCsat) + (total * csat)) / (lastCount + total);
      arr[arr.length - 1].count += total;
      return arr;
    } else {
      return arr.concat([{
        x: moment.utc(date).startOf(timePeriod).valueOf(),
        y: csat,
        count: total,
      }]);
    }
  };
}

function getData(csatByDate, intl) {
  if (!Array.isArray(csatByDate) || csatByDate.length <= 0) {
    return {
      data: [],
      tooltipDateFormatter: () => null,
      xAxisDateFormatter: () => null,
    };
  }

  const firstDate = csatByDate[0].date;
  const lastDate = csatByDate[csatByDate.length - 1].date;
  const monthsCount = moment(lastDate).diff(moment(firstDate), 'months');

  if (monthsCount < 3) {
    return {
      data: csatByDate.map(({ date, positive, total }) => {
        return {
          x: Date.parse(date),
          y: (positive / total) * 100,
          count: total,
        };
      }),
      tooltipDateFormatter: ms => moment.utc(ms).format('dddd, D MMM Y'),
      xAxisDateFormatter: ms => moment.utc(ms).format('D MMM<br/>Y'),
    };
  } else if (monthsCount < 12) {
    return {
      data: csatByDate.reduce(getCollapseTimePeriodFunction('isoWeek'), []),
      tooltipDateFormatter: ms => {
        return intl.formatMessage({ id: 'week' }) + moment.utc(ms).format(' W, Y');
      },
      xAxisDateFormatter: ms => {
        return intl.formatMessage({ id: 'week' }) + moment.utc(ms).format(' W<br/>Y');
      },
    };
  } else {
    return {
      data: csatByDate.reduce(getCollapseTimePeriodFunction('month'), []),
      tooltipDateFormatter: ms => moment.utc(ms).format('MMMM Y'),
      xAxisDateFormatter: ms => moment.utc(ms).format('MMM<br/>Y'),
    };
  }
}

const styles = {
  wrapper: {
    padding: 15
  },
};

class CsatLineChart extends Component {

  render() {

    const intl = this.props.intl;
    const scoreTitle = intl.formatMessage({
      id: 'csat',
      defaultMessage: 'CSAT',
    });

    const {
      data,
      tooltipDateFormatter,
      xAxisDateFormatter,
    } = getData(this.props.answersReport.csatByDate, intl);

    const chartConfig = {
      chart: {
        height: this.props.height - (styles.wrapper.padding * 2),
        width: this.props.width - (styles.wrapper.padding * 2),
      },
      title: null,
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          const score = ReactHighcharts.Highcharts.numberFormat(this.y, 1);
          const countMessage = intl.formatMessage({ id: 'numberOfAnswers' }, { count: this.point.count });
          const date = tooltipDateFormatter(this.x);
          return `
            <b>${scoreTitle}: ${score}</b>
            <br/>
            ${countMessage} 
            <br/>
            ${date}
          `;
        },
      },
      xAxis: {
        type: 'datetime',
        labels: {

          // ...labels,
          formatter: function () {
            return xAxisDateFormatter(this.value);
          },
          style: {
            color: grey500,
          },
        },
      },
      yAxis: {
        title: {
          text: scoreTitle,
          style: {
            color: grey500,
          },
        },
        min: 0,
        max: 100,
        tickInterval: this.props.staticYAxisScale ? 5 : null,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}%',
          },
        },
      },
      series: [{
        data,
      }],
    };

    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{ id: this.props.uniqueId }}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(CsatLineChart),
  graphql`
    fragment CsatLineChart_answersReport on AnswersReport {
      csatByDate {
        date
        positive
        total
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/CsatLineChart/CsatLineChart.js